import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterApoios() {
        return axiosJwt
            .get(`${api}/gescon/gerentes/apoios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDisponiveis() {
        return axiosJwt
            .get(`${api}/gescon/gerentes/apoios/disponiveis`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirApoios(apoios) {
        return axiosJwt
            .post(`${api}/gescon/gerentes/apoios`, apoios)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirApoios(apoioId) {
        return axiosJwt
            .delete(`${api}/gescon/gerentes/apoios/${apoioId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
